import { render, staticRenderFns } from "./PlanEdition.vue?vue&type=template&id=bb96f5c8&scoped=true&"
import script from "./PlanEdition.vue?vue&type=script&lang=js&"
export * from "./PlanEdition.vue?vue&type=script&lang=js&"
import style0 from "./PlanEdition.vue?vue&type=style&index=0&id=bb96f5c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb96f5c8",
  null
  
)

export default component.exports